// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_ConfigSaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for saving invoice provider configuration
 */
import { registerContract } from './validate'

export interface Invoice_ConfigSaveInput {
franchise_id: number
provider_code: string
api_key?: string
sandbox_mode?: number
monthly_emission_limit?: number
config?: string
}

registerContract('Invoice_ConfigSaveInput', {
  franchise_id:           { type: 'number',  required: true },
  provider_code:          { type: 'string',  required: true },
  api_key:                { type: 'string',  required: false },
  sandbox_mode:           { type: 'number',  required: false },
  monthly_emission_limit: { type: 'number',  required: false },
  config:                 { type: 'string',  required: false },
})
